import * as React from "react";
import "./header.css";

export default function Header () {
    return (
        <header className="app-header">
            <h2>Coaching App <small>beta</small></h2>
        </header>
    )
}